import { useCallback } from "react";
import { useParams } from "react-router-dom";
import TripLiveView from "@/components/TripLiveView";
import { brand } from "@/lib/brand";

const BACKEND = process.env.REACT_APP_BACKEND_URL;

export default function TripShare() {
  const { shareToken } = useParams();
  const load = useCallback(async () => {
    const r = await fetch(`${BACKEND}/api/track/shared/${shareToken}`);
    if (!r.ok) {
      const d = await r.json().catch(() => ({}));
      const err = new Error("unavailable");
      err.response = { data: { detail: d.detail || "This tracking link is not available." } };
      throw err;
    }
    return r.json();
  }, [shareToken]);

  return (
    <div className="min-h-screen bg-sand-50 py-8 px-4" data-testid="trip-share-page">
      <div className="max-w-4xl mx-auto">
        <div className="flex items-center gap-2 mb-6">
          <span className="font-serif text-2xl text-charcoal-800">{brand?.name || "Live pet trip"}</span>
          <span className="text-charcoal-400 text-sm">· live tracking</span>
        </div>
        <div className="bg-white rounded-2xl p-5 shadow-sm">
          <TripLiveView load={load} mapHeight={500} />
        </div>
        <p className="text-xs text-charcoal-400 mt-4 text-center">Shows the tracking phone's location. The person sharing can turn this link off at any time.</p>
      </div>
    </div>
  );
}
